import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import GeographicalSoilList from "../components/GeographicalSoilList";

const GeographicalSoilMasterPage = () => {
  return (
    <>
      <Breadcrumb title="Geography Wise Soil Master" />
      <GeographicalSoilList />
    </>
  );
};

export default GeographicalSoilMasterPage;
